import { useEffect, useRef } from 'react';
import type { StoreApi } from 'zustand';

import { JsonTreeStoreContext } from './context';
import { createJsonTreeStore } from './store';
import type { JsonTreeStore } from './types';

type JsonTreeStoreProviderProps = {
  startExpanded: boolean;
  children: React.ReactNode;
};

export function JsonTreeStoreProvider({
  startExpanded,
  children,
}: JsonTreeStoreProviderProps) {
  const storeRef = useRef<StoreApi<JsonTreeStore>>();

  if (!storeRef.current) {
    storeRef.current = createJsonTreeStore(startExpanded);
  }

  useEffect(() => {
    const store = storeRef.current;
    if (!store) {
      return;
    }

    const currentState = store.getState();
    if (
      currentState.defaultExpanded === startExpanded &&
      currentState.nodeStates.size === 0
    ) {
      return;
    }

    store.setState({
      defaultExpanded: startExpanded,
      nodeStates: new Map(),
    });
  }, [startExpanded]);

  return (
    <JsonTreeStoreContext.Provider value={storeRef.current}>
      {children}
    </JsonTreeStoreContext.Provider>
  );
}
